import { useSystemStore } from "@/stores/systemStore";
import { authService } from "@/lib/authService";

// Client-side V1 guard only; Firestore/backend enforcement is a separate phase.
export function requireSystemAdmin(): string {
  const state = useSystemStore.getState();
  if (
    !state.adminAccessResolved ||
    !state.isSystemAdmin ||
    !state.uid ||
    authService.getCurrentUser()?.uid !== state.uid
  )
    throw new Error("Admin access is not available.");
  return state.uid;
}
